import { useContext } from "react";
import NavigasiAdmin from "../../components/NavigasiAdmin";
import { UserContext } from "../../context/userContext";

function AdminHome() {
  document.title = "Admin Home";

  const [state, dispatch] = useContext(UserContext);
  console.log("Log State di Admin Home : ", state);

  return (
    <>
      <NavigasiAdmin />
      <div className="adminhome-section container">
        <p className="fw-bold fs-4 my-5">Admin Home</p>
        <h1>Welcome to Admin Dashboard</h1>
      </div>
    </>
  );
}

export default AdminHome;
